<template>
  <NotificationIcon v-bind:value="value"></NotificationIcon>
</template>

<script>
  import NotificationIcon from './NotificationIcon'

  export default {
    name: 'MessageNotification',
    props: ['value'],
    components: {
      'NotificationIcon': NotificationIcon
    }
  }
</script>
